import {get} from '@github/webauthn-json';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Notification} from '../classes/Notification';
import locale from '../locale/Localization';
import {startSessionPolling} from '../sagas/sagaActions';
import {
  finishAuthentication,
  startAuthentication
} from '../script/webauthn-service';
import {
  addArchives,
  addNotifications,
  addRoles,
  addUser
} from '../store/appActions';
import LoginDialog from './LoginDialog';

/**
 * Map the properties.
 * @param {*} dispatch
 * @return {Function} the add user function.
 */
function mapDispatchToProps(dispatch) {
  return {
    addUser: (user) => dispatch(addUser(user)),
    addRoles: (roles) => dispatch(addRoles(roles)),
    addArchives: (archives) => dispatch(addArchives(archives)),
    startSessionPolling: () => dispatch(startSessionPolling()),
    addNotifications: (notification) => dispatch(addNotifications(notification))
  };
}

/**
 * ConnectedAuth component for authentication logic.
 */
class ConnectedLogin extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false
    };
  }

  /**
   * Handle the user name authentication
   * @param {string} userName
   */
  handleAuthentication = async (userName: string) => {
    // const uuid = uuidv4();
    const publicKeyCredentialCreationOptions = await startAuthentication(
      userName
    );
    // fix problems with null objects
    // if we use resident credential we can delete allowCredentials because this is ignored on
    // authentications with resident credentials
    // resident credentials not supported by firefox on mac
    publicKeyCredentialCreationOptions.allowCredentials.map(
      this.deleteInvalidTransports
    );
    const credential = await get({
      publicKey: publicKeyCredentialCreationOptions
    });
    const authenticationResult = await finishAuthentication(
      userName,
      credential
    );

    if (authenticationResult.success) {
      this.props.addUser({user: authenticationResult.person});
      this.props.addRoles({roles: authenticationResult.roles});
      this.props.addArchives({
        archives: authenticationResult.person.archiveAccess
      });
      this.props.startSessionPolling();
      this.props.addNotifications([
        new Notification(locale.loginSuccessful, 'success', 6000)
      ]);
    } else {
      this.props.addNotifications([
        new Notification(locale.loginFailed, 'error', 6000)
      ]);
    }
  };

  /**
   * This function deletes invalid transports values
   * from excludeCredentials array.
   * @param {Object} item item The array item.
   */
  deleteInvalidTransports(item) {
    if (item.transports === null) {
      delete item.transports;
    }
  }

  /**
   * React render function.
   * @return {string} the component contents.
   */
  render() {
    return (
      <React.Fragment>
        <Button
          color='inherit'
          onClick={() => this.setState({dialogOpen: true})}
        >
          {locale.login}
        </Button>
        <LoginDialog
          handleLogin={(userName) => this.handleAuthentication(userName)}
          handleOpen={() => this.setState({dialogOpen: true})}
          handleClose={() => this.setState({dialogOpen: false})}
          open={this.state.dialogOpen}
        ></LoginDialog>
      </React.Fragment>
    );
  }
}

ConnectedLogin.propTypes = {
  addUser: PropTypes.func.isRequired,
  addRoles: PropTypes.func.isRequired,
  addArchives: PropTypes.func.isRequired,
  startSessionPolling: PropTypes.func.isRequired,
  addNotifications: PropTypes.func.isRequired
};

const Login = connect(null, mapDispatchToProps)(ConnectedLogin);
export default Login;
